import { useGlobalState } from '../../Provider/AppProvider';
import { getAvatarUrl } from '../../utils/api';

function getInitials(user: { firstName?: string; lastName?: string; username?: string; email?: string } | null): string {
    if (!user) return '?';
    const first = (user.firstName || user.username || '').trim().charAt(0);
    const last = (user.lastName || '').trim().charAt(0);
    if (first && last) return `${first}${last}`.toUpperCase();
    if (first) return first.toUpperCase();
    if (user.email) return user.email.charAt(0).toUpperCase();
    return '?';
}

const SidebarProfile = () => {
    const { user } = useGlobalState();

    const avatarPath = user?.avatarUrl ?? (user as { avatar_url?: string })?.avatar_url;
    const avatarUrl = getAvatarUrl(avatarPath ?? undefined);
    const displayName = user?.firstName && user?.lastName
        ? `${user.firstName} ${user.lastName}`.trim()
        : user?.name || user?.username || user?.email || 'Basma Admin';

    return (
        <div className="sidebar-profile" title={displayName}>
            {avatarUrl ? (
                <img src={avatarUrl} alt="" className="avatar sidebar-profile-avatar" />
            ) : (
                <div className="sidebar-profile-avatar sidebar-profile-placeholder">{getInitials(user)}</div>
            )}
            <div className="sidebar-profile-info">
                <strong>{displayName}</strong>
                <small>{user?.email || user?.role || 'Administrator'}</small>
            </div>
        </div>
    );
};

export default SidebarProfile;
